import { Typography, useMediaQuery, useTheme } from "@material-ui/core";
import { memo, useCallback } from "react";

import { Checkbox } from "@chhjit/react-components";
import clsx from "clsx";
import { useTileCardStyles } from "./styles";
import { TileCardProps } from "./types";

export const TileCard = <T extends string | number = string>({
  label,
  icon,
  isSelected,
  onChange,
  value,
  variant = "horizontal",
}: TileCardProps<T>) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"), {
    noSsr: true,
  });

  const styles = useTileCardStyles({
    variant,
  });

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      onChange(value);
    },
    [onChange, value],
  );

  return (
    <button
      className={clsx(
        styles.root,
        isSelected && styles.selected,
        variant === "horizontal" && styles.horizontal,
        variant === "vertical" && !isMobile && styles.vertical,
        (variant === "vertical-compact" ||
          (isMobile && variant === "vertical")) &&
          styles.verticalCompact,
      )}
      onClick={onClick}
      id={`ob-${String(value)}`}
    >
      <div className={styles.labelAndCheckbox}>
        <Checkbox
          checked={isSelected}
          variant="outline"
          id={`ob-checkbox-${String(value)}`}
          className={styles.checkbox}
          aria-label={label}
          tabIndex={-1}
        />

        <Typography variant="h5" component="p" className={styles.label}>
          {label}
        </Typography>
      </div>

      <div className={styles.icon}>{icon}</div>
    </button>
  );
};

export const TileCardMemo = memo(TileCard) as typeof TileCard;
